<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]">
    <q-linear-progress v-if="this.isFetching" indeterminate/>
    <q-form v-else @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          :options="this.residentsOptions"
          label="Проект для дублирования подъезда"
          optionValueKey="project_id"
          optionLabelKey="project_short_name"
          :value="this.formData.to_project_id || ''"
          @change="(value) => onChange('to_project_id', value)"
          :required="true"
          :clearable="false"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getProjectsById  } from "@/views/ShellProjects/services";
import { appActions } from "@/services/store/modules/app_module/app_actions";

export default {
  name: "copy-paste-entrance-properties",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residentsOptions: [],
      formData: {
        from_project_id: this.data?.body.project_id || "",
        entrance:  this.data?.body?.entrance || "",
        to_project_id: "",
      },
    };
  },
  async mounted() {
    this.isFetching = true;
    console.log("DATA ", this.data?.body)
    await this.getProjectsOptions(this.data?.body?.project_id);
    
    this.isFetching = false;
  },
  methods: {
    async getProjectsOptions(project_id) {
      const res = await getProjectsById(project_id);
      this.residentsOptions = res || [];
    },
   
    async onChange(key, value) {
      this.formData[key] = value;
      return;
    },
    async onSubmit() {
      this.loading = true;
      const formData = {
        from_project_id: this.formData.from_project_id,
        to_project_id: this.formData.to_project_id,
        entrance: this.formData.entrance,
      }

      try {
        await this.data?.onSubmit(formData);
      } catch (error) {
      } finally {
        this.loading = false;
        this.$store.commit(appActions.closeModal());
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 20px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
.form__item_date {
  display: flex;
  flex-direction: column;

}
.form__item_date span {
  font-size: 12px;
  padding-left: 1px;
  color: gray;
}
</style>
